var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhyInvestImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 382,
    height: 555,
    viewBox: "0 0 382 555",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.047 102.112C358.706 140.349 472.829 89.9787 517.448 159.927C562.971 231.291 516.842 326.683 475.281 400.334C434.864 471.957 376.914 548.898 294.793 554.501C217.705 559.761 171.758 475.435 113.156 425.042C73.916 391.298 32.3879 361.627 14.19 313.204C-5.32646 261.273 -2.97493 206.856 10.9952 153.202C30.859 76.9129 35.6055 16.3271 113.156 1.86969C192.749 -12.9682 213.154 64.7929 285.047 102.112Z",
    fill: "#EAF3FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyInvestImage);
export default __webpack_public_path__ + "static/media/WhyInvestImage.416e3a68e3eb2a89644610413652222e.svg";
export { ForwardRef as ReactComponent };